export default __webpack_public_path__ + "LifeTime_OnePager_Transactionsa731a8793f70ead09132acb49ca324cf.pdf";